import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { useMonacoThemeVariant, MONACO_THEME_VARIANTS, type MonacoThemeVariant } from "../../theme";

export function CodeEditorThemeSwitcher() {
  const { variant, setVariant } = useMonacoThemeVariant();

  return (
    <fieldset className="flex gap-5">
      <legend className="sr-only">Code editor theme preference</legend>
      {MONACO_THEME_VARIANTS.map(opt => {
        const inputId = `code-editor-theme-${opt.value}`;
        return (
          <div key={opt.value} className="flex items-center gap-2">
            <RadioButton
              inputId={inputId}
              name="code-editor-theme"
              value={opt.value}
              onChange={(e: RadioButtonChangeEvent) => setVariant(e.value as MonacoThemeVariant)}
              checked={variant === opt.value}
            />
            <label htmlFor={inputId}>{opt.label}</label>
          </div>
        );
      })}
    </fieldset>
  );
}
